module.exports = "/_next/static/images/noodlestand_menu_top-9bdb168cabeebc4f76384c93779c3f4f.jpg";